import React from 'react';
import { OpeningFunction, ProductType } from '@inter-ikea-storageone/range';
import Box from 'ui/Box';
import { useCore } from 'contexts/core';
import { changeDrawerOpeningFunction } from 'rangeConfig/shared/utils/frontLayouts';
import { BestaOpeningFunctionComponent } from '@inter-ikea-storageone/range-besta';
import { useSelector } from 'react-redux';
import { getSelectedProducts } from 'ducks/products';
import { useIntl } from 'react-intl';
import { store } from 'ducks';
import { useBehaviorTracker } from 'contexts/behaviors';
import SegmentedControl from '@ingka/segmented-control';

const FrontOpeningFunctionToggleSelectedMenu = () => {
  const coreApi = useCore();
  const rootState = store.getState();
  const { formatMessage } = useIntl();
  const selectedEntity = coreApi.entities.findSelectedEntity();
  const selectedProduct = useSelector(getSelectedProducts);
  const behaviorTracker = useBehaviorTracker();

  const currentOpeningFunction = selectedEntity?.getComponent<BestaOpeningFunctionComponent>(
    BestaOpeningFunctionComponent.id
  )?.openingFunction;

  const handleSelect = (openingFunction: OpeningFunction) =>
    behaviorTracker.custom(() => {
      if (selectedEntity && selectedProduct !== null) {
        changeDrawerOpeningFunction(
          selectedEntity,
          openingFunction,
          rootState?.products?.inMarket,
          coreApi,
          false
        );
      }
    });

  const options = [
    {
      id: 'push-open',
      label: 'storageone.productPushToOpen',
      openingFunction: ProductType.BESTA_PUSH_OPEN,
      onSelect: () => handleSelect(ProductType.BESTA_PUSH_OPEN)
    },
    {
      id: 'soft-closing',
      label: 'storageone.productSoftClosing',
      openingFunction: ProductType.BESTA_SOFT_CLOSING,
      onSelect: () => handleSelect(ProductType.BESTA_SOFT_CLOSING)
    }
  ];

  const items = options.map(option => ({
    id: option.id,
    label: formatMessage({ id: option.label }),
    icon: ''
  }));

  const onToggleSelect = (index: number) => {
    options[index].onSelect();
  };

  const selectedIndex = options.findIndex(
    option => option.openingFunction === currentOpeningFunction
  );

  return (
    <Box mt="l" mb="0">
      <SegmentedControl
        data-testid="handle-front-type-toggle"
        items={items}
        onClick={(_e, value) => onToggleSelect(value)}
        activeIndex={selectedIndex}
      />
    </Box>
  );
};

export default FrontOpeningFunctionToggleSelectedMenu;
